module.exports = __webpack_public_path__ + "img/dice2p1.a0e79ba5.png";